// Utility-Funktion für dynamische Tab-Titel basierend auf Organisation
export const updateTabTitle = (organizationId) => {
  let title = 'Bundesenergie Nord'; // Standard-Titel
  
  switch (organizationId) {
    case 4:
      title = 'Bundesenergie Nord';
      break;
    case 6:
      title = 'Energie+';
      break;
    default:
      title = 'Bundesenergie Nord';
      break;
  }
  
  document.title = title;
};

// Funktion zum Zurücksetzen des Tab-Titels auf den Standard
export const resetTabTitle = () => {
  document.title = 'Bundesenergie Nord';
}; 